const UK_COUNTRY_NAME = "United Kingdom";

export default function sortShippingCountries(countries = []) {
  return [...countries].sort((a, b) => {
    if (a.name === UK_COUNTRY_NAME) {
      return -1;
    }
    if (b.name === UK_COUNTRY_NAME) {
      return 1;
    }
    return a.name.localeCompare(b.name);
  });
}
